import * as React from 'react';
import { IOrthodonticReferral } from '../../../../models/IOrthodonticReferral';
import { Table } from 'soprasteria-ui-library';
import { PATIENT, ORTHODONTIC_REFERRAL } from "../../../../utils/RouteConstants";
import { Link } from 'react-router-dom';
import { dateTimeToDateString } from "../../../../helpers/DateHelper";

interface IOrthodonticReferralPatientOrthodonticReferrals {
    orthodonticReferral: IOrthodonticReferral;
}

export const OrthodonticReferralPatientOrthodonticReferrals: React.FunctionComponent<IOrthodonticReferralPatientOrthodonticReferrals> = ({ orthodonticReferral }) => {

    const renderTableLink = (key: React.Key, linkText: string, refOrthodonticReferral: IOrthodonticReferral) => {
        const url = `/${PATIENT}/${refOrthodonticReferral.patientGuidId}/${ORTHODONTIC_REFERRAL}/${refOrthodonticReferral.orthodonticReferralId}`;
        return <Link key={key}  to={`${url}`}>{linkText}</Link>
    }

    return (
        orthodonticReferral.patientOrthodonticReferrals ?
        <>
            <div className="row readonly-less-margin">
                <h5 className="col-6">Tidigare remisser</h5>
            </div>
            <div className="row readonly-less-margin">
                <div className="col-12">
                    <Table hoverableRows>
                        <thead>
                            <tr>
                                <th>Datum skickad</th>
                                <th>Remiss-ID</th>
                                <th>Remittent</th>
                                <th>Konsult</th>
                                <th>Beslut</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                orthodonticReferral.patientOrthodonticReferrals.length > 0 ?
                                    orthodonticReferral.patientOrthodonticReferrals.map((orthodonticReferral, key) => {
                                        return (
                                            <tr key={key} className="clickable-row">
                                                <td className="table-data-link">{renderTableLink(key, orthodonticReferral.sentDate ? dateTimeToDateString(orthodonticReferral.sentDate) : "", orthodonticReferral)}</td>
                                                <td className="table-data-link">{renderTableLink(key, orthodonticReferral.orthodonticReferralNumber ?? "", orthodonticReferral)}</td>
                                                <td className="table-data-link">{renderTableLink(key, orthodonticReferral.referrerCareProvider.displayCareProviderName ?? "", orthodonticReferral)}</td>
                                                <td className="table-data-link">{renderTableLink(key, orthodonticReferral.consultantCareProvider.name ?? "", orthodonticReferral)}</td>
                                                <td className="table-data-link">{renderTableLink(key, orthodonticReferral.orthodonticReferralDecision ?? "", orthodonticReferral)}</td>
                                            </tr>
                                        )
                                    })
                                    :
                                    <tr><td colSpan={5}>Det finns inga tidigare ortodontiremisser för den här patienten</td></tr>
                            }
                        </tbody>
                    </Table>
                </div>
            </div>
            <hr />                
        </>
        : null
    )
}